<template>
	<main>
		
		<!-- HERO -->
		<div class="scroll_menu0"></div>
		<VideoHero />

		<!-- INTRO TEXT -->
		<ArticleOneCol
			:headline_first="$t('textBlock.intro.header_first')"
			:headline_second="$t('textBlock.intro.header_second')"
			:num_cols="1"

			:text_col1="$t('textBlock.intro.text_col1')"
			:text_col2="$t('textBlock.intro.text_col2')"
			:text_col3="$t('textBlock.intro.text_col3')"

			background_color="#009CA6"
			text_color="#fff"
			background_image=""
			btn_text=""
			btn_url=""
			
			icon=""

			:useAccordion="false"
			text_before_accordion=""
			text_accordion_pre_image=""
			text_accordion_image=""
			text_accordion_post_image=""
			person_image=""
			image_caption=""
			
			component_class="intro"
		/>

		<!-- LEDAREN -->
		<Leader 
			:ita_headline_first="$t('textBlock2Col.leader.headline_first')"
			:ita_headline_second="$t('textBlock2Col.leader.headline_second')"

			:text_before_accordion="$t('textBlock2Col.leader.text_before_accordion')"
			:text_accordion_pre_image="$t('textBlock2Col.leader.text_accordion_pre_image')"
			:text_accordion_image="$t('textBlock2Col.leader.text_accordion_image')"
			:text_accordion_post_image="$t('textBlock2Col.leader.text_accordion_post_image')"
			
			image="01_leader.jpg"
			person_image=""
			image_caption=""

			background_image="grid_02_green.png"
			:background_image_fullwidth="false"
			background_color="#F9F5F3"
			text_color="#222"

			:boldHeaderFirst="false"
			:useAccordion="true"
			:extraContent="$t('empty')"
			:textToLeft="false"

			extraClass="circleImage"

		/>
		
		<!-- NUMBERS -->
		<NumbersSix />

		<!-- NEW SECTION START -->
		<!-- Bolstering - yellow -->
		<div class="scroll_menu1"></div>
		<SectionHeader
			section_start_header="Bolstering the regional innovation ecosystem"
			background_color="#FFE500"
			text_color="#222"
		/>

		<!-- Ripple effect intro DESIGN 2 -->
		<Article 
			:ita_headline_first="$t('rippleEffect.section_header_first')"
			:ita_headline_second="$t('rippleEffect.section_header_second')"

			:text_before_accordion="$t('rippleEffect.text_before_accordion')"
			:text_accordion_pre_image="$t('textBlock2Col.consortia.text_accordion_pre_image')"
			:text_accordion_image="$t('textBlock2Col.consortia.text_accordion_image')"
			:text_accordion_post_image="$t('textBlock2Col.consortia.text_accordion_post_image')"
			
			image="article_ripple_opt.png"
			person_image=""
			image_caption=""

			background_image="grid_01_journey.png"
			:background_image_fullwidth="false"
			background_color="#fff"
			text_color="#222"

			:boldHeaderFirst="true"
			:useAccordion="false"
			:extraContent="$t('empty')"

			:textToLeft="false"
			extraClass="ripple_effect"
		/>


		<!-- Ripple effect intro -->
		<!-- <RippleEffectIntro
			:ita_headline_first="$t('rippleEffect.section_header_first')"
			:ita_headline_second="$t('rippleEffect.section_header_second')"
			:text_before_accordion="$t('rippleEffect.section_text')"	
			:text_before_accordion2="$t('rippleEffect.section_text2')"	
		/> -->

		<!-- RippleEffect -->
		<RippleEffect />

		<!-- GARY CASS DESIGN 2 -->
		
		<Article 
			:ita_headline_first="$t('textBlock.biofoam.header_first')"
			:ita_headline_second="$t('textBlock.biofoam.header_second')"

			:text_before_accordion="$t('textBlock.biofoam.text_before_accordion')"
			:text_accordion_pre_image="$t('textBlock.biofoam.text_accordion_pre_image')"
			text_accordion_image=""
			text_accordion_post_image=""
			
			image="article_foam.jpg"
			person_image=""
			image_caption=""

			background_image=""
			:background_image_fullwidth="false"
			background_color="#FFF7DD"
			text_color="#222"

			:boldHeaderFirst="true"
			:useAccordion="true"
			:extraContent="$t('empty')"
			:textToLeft="true"

			extraClass="section_foam"
		/>

		<!-- BIO FOAM -->
		<!-- cass material -->
		<!-- <ArticleOneCol
			:headline_first="$t('textBlock.biofoam.header_first')"
			:headline_second="$t('textBlock.biofoam.header_second')"
			:num_cols="1"
			
			:text_col1="$t('textBlock.biofoam.text_col1')"
			:text_col2="$t('textBlock.intro.text_col2')"
			:text_col3="$t('textBlock.intro.text_col3')"

			:useAccordion="true"
			text_before_accordion=""
			:text_accordion_pre_image="$t('textBlock.biofoam.text_accordion_pre_image')"
			text_accordion_image=""
			text_accordion_post_image=""
			person_image=""
			image_caption="Person name in here"
			
			background_color="#FFF7DD"
			text_color="#222"
			background_image=""
			
			btn_text=""
			:btn_url="$t('textBlock.intro.btn_url')"
			
			icon=""

			component_class=""
		/> -->

		<!-- Journey -->
		<Journey />
		
		<!-- NEW SECTION START -->
		<!-- Global - dark green -->
		<div class="scroll_menu2"></div>
		<SectionHeader
			section_start_header="Global innovation partnerships"
			background_color="#0E4E65"
			text_color="#ffffff"
		/>

		<!-- TEXT N ICON -->
		<!-- Barcelona -->
		<ArticleOneCol
			:headline_first="$t('textBlock.artIcon.header_first')"
			:headline_second="$t('textBlock.artIcon.header_second')"
			:num_cols="1"
			
			:text_col1="$t('textBlock.artIcon.text_col1')"
			:text_col2="$t('textBlock.intro.text_col2')"
			:text_col3="$t('textBlock.intro.text_col3')"

			:useAccordion="true"
			text_before_accordion=""
			text_accordion_pre_image=""
			text_accordion_image=""
			:text_accordion_post_image="$t('textBlock.artIcon.text_accordion_post_image')"
			person_image=""
			image_caption="Person name in here"
			
			background_color="#fff"
			text_color="#222"
			background_image=""
			
			btn_text=""
			:btn_url="$t('textBlock.intro.btn_url')"
			
			icon="icon.svg"

			component_class=""

		/>

		<!-- Image with Bg -->
		<ImageBg 
			image="13_city.jpg"
			background_image="grid_02_green.png"
			:background_image_fullwidth="false"
			background_color="#fff"
			:textToLeft="false"
		/>
		
		<!-- NUMBERS -->
		<NumbersTwo />

		<!-- shubba -->
		<Article 
			:ita_headline_first="$t('textBlock2Col.shubba.header_first')"
			:ita_headline_second="$t('textBlock2Col.shubba.header_second')"

			:text_before_accordion="$t('textBlock2Col.shubba.text_before_accordion')"
			:text_accordion_pre_image="$t('textBlock2Col.shubba.text_accordion_pre_image')"
			:text_accordion_image="$t('textBlock2Col.shubba.text_accordion_image')"
			:text_accordion_post_image="$t('textBlock2Col.shubba.text_accordion_post_image')"
			
			image="article_shubba.jpg"
			person_image=""
			image_caption=""

			background_image="grid_02_green.png"
			:background_image_fullwidth="false"
			background_color="#0E4E65"
			text_color="#fff"

			:boldHeaderFirst="true"
			:useAccordion="true"
			:extraContent="$t('empty')"
			:textToLeft="true"

			extraClass="section_shubba"
		/>

		<!-- consortia mari-loise -->
		<Article 
			:ita_headline_first="$t('textBlock2Col.consortia.header_first')"
			:ita_headline_second="$t('textBlock2Col.consortia.header_second')"

			:text_before_accordion="$t('textBlock2Col.consortia.text_before_accordion')"
			:text_accordion_pre_image="$t('textBlock2Col.consortia.text_accordion_pre_image')"
			:text_accordion_image="$t('textBlock2Col.consortia.text_accordion_image')"
			:text_accordion_post_image="$t('textBlock2Col.consortia.text_accordion_post_image')"
			
			image="article_consortia.jpg"
			person_image=""
			image_caption=""

			background_image="grid_02_green.png"
			:background_image_fullwidth="false"
			background_color="#ebf5f0"
			text_color="#222"

			:boldHeaderFirst="true"
			:useAccordion="true"
			:extraContent="$t('empty')"

			:textToLeft="false"
			extraClass=""
		/>

		<!-- NEW SECTION START -->
		<!-- Accelerating processes - light green -->
		<div class="scroll_menu3"></div>
		<SectionHeader
			section_start_header="Accelerating processes"
			background_color="#009CA6"
			text_color="#ffffff"
		/>

		<!-- C-GREEN TEXT -->
		<ArticleOneCol
			:headline_first="$t('textBlock.cgreen.header_first')"
			:headline_second="$t('textBlock.cgreen.header_second')"
			:num_cols="1"

			:text_col1="$t('textBlock.cgreen.text_col1')"
			:text_col2="$t('textBlock.cgreen.text_col2')"
			:text_col3="$t('textBlock.cgreen.text_col3')"

			background_color="#ffffff"
			text_color="#222222"
			background_image=""
			btn_text=""
			btn_url=""
			
			icon=""

			:useAccordion="true"
			text_before_accordion=""
			:text_accordion_pre_image="$t('textBlock.cgreen.text_accordion_pre_image')"
			text_accordion_image=""
			text_accordion_post_image=""

			person_image=""
			image_caption=""
			
			component_class=""
		/>

		<!-- C-GREEN MACHINE -->
		<Lightbox
			image="cgreen_drum.svg"
			background_color="#fff"
		/>

		<div class="scroll_menu4"></div>

	</main>
	<Footer />

	<vue-cookie-comply
		headerTitle=""
		headerDescription="We use cookies to improve your user experience on this web page. By clicking I accept you agree to it."
		acceptAllLabel="I accept"
		preferencesLabel="Privacy Policy"
	>

	<template v-slot:modal-header>
		<div class="policy_scroll">
		<h3>Privacy Policy</h3>
		<p>This is how RISE Processum uses cookies and local data storage</p><h4 class="cookie_header">What are cookies and local data storage?</h4><p>When you visit our websites, various types of data are stored locally on your device via your web browser. This locally stored data can be used to adapt content and functionality, thereby improving your experience while visiting the website.</p><p>The most common form of local data storage is cookies. Cookies are small text files that are stored on your device (computer, mobile phone or tablet). These files allow us to recognise your browser.</p><p>In addition to cookies, we also use similar techniques such as pixel tags, such as pixels from Facebook and LinkedIn, a technique for recognising cookies and identifiers and making it easier for third parties to place cookies on your device. Both RISE Processum and third parties may store data locally on your device whenever you use our services.</p><h4 class="cookie_header">This is how RISE Processum uses locally stored data</h4><p>RISE Processum, our subcontractors (e.g. suppliers of analytical tools) and third parties (e.g. social media providers and their suppliers) store data locally on your device.</p><p>We use locally stored data to:</p><ul><li>Deliver and adapt content to your device and the browser you are using.</li><li>Save your personal settings, for example your selected language.</li><li>Improve ri.se and ensure that everything works as well as possible.</li><li>Reach you with marketing and personalised information via other channels.</li><li>Measure and analyse traffic and user behaviour.</li></ul><h4 class="cookie_header">How can you remove cookies and locally stored data?</h4><p>You will normally find an overview of stored cookies in your browser settings. Settings also allow you to remove unwanted cookies, choose whether to accept the storage of cookies from the websites you visit or from third parties connected to them, and whether you want to be notified every time a cookie is saved. More information about cookies and how you can manage them is available from the <a href="https://pts.se/en/english-b/regulations2/legislation/electronic-communications-act/q/qa-about-cookies-for-users/">Swedish Post and Telecom Authority (PTS) website</a>.</p><h4 class="cookie_header">Instructions for managing cookies in your browser</h4><p>Below you will find instructions for managing cookies in various browsers. Please note that these procedures may change and that the descriptions below will not necessarily be updated to reflect these changes.</p><ul><li><a href="https://support.apple.com/kb/PH21411?viewlocale=sv_SE&amp;locale=sv_SEhttps://support.apple.com/sv-se/HT201265">Safari</a></li><li><a href="https://support.apple.com/sv-se/HT201265">Safari för iPhone och iPad</a></li><li><a href="https://support.google.com/chrome/answer/95647?hl=sv">Google Chrome</a></li><li><a href="https://support.microsoft.com/sv-se/help/17442/windows-internet-explorer-delete-manage-cookies">Microsoft Internet Explorer</a></li><li><a href="https://support.mozilla.org/sv/products/firefox/protect-your-privacy/cookies">Mozilla Firefox</a></li><li><a href="https://www.opera.com/help/tutorials/security/privacy/">Opera</a></li></ul><h4 class="cookie_header">Examples of cookies and locally stored data used by RISE Processum</h4><p>Below you will find examples of the cookies and pixel tags we use to improve ri.se and ensure that everything works as well as possible.</p><h3>First party cookies: (cookies by <a href="http://www.ri.se">www.ri.se</a>)</h3><p><strong>cookie-agreed</strong><br/>Used to determine if the user has seen the cookie message before or not. The purpose is to only show the cookie message the first time the user visits the website after clicking "I accept".<br/>Storage period: 100 days</p><p><strong>SSESS (followed by multiple digits)</strong><br/>Drupal session cookie used when an authoRISE Processumd user (in other words, a logged in user) logs in. An initial SESS cookie is set when you browse anonymously on the website which looks to see if you are logged.<br/>Storage period: Technically 23 days, although the cookie looses its significance when the user is logged out due to inactivity.</p><h3>Third party cookies (cookies by third party website)</h3><p><strong>ga, gat, gid</strong><br/>Google Analytics is Google’s analytics tool that helps website and app owners to understand how their visitors engage with their properties. It may use a set of cookies to collect information and report website usage statistics without personally identifying individual visitors to Google. The main cookie used by Google Analytics is the ‘__ga’ cookie.<br/>Storage period: 2 years</p><p><strong>NID</strong><br/>Most Google users will have a preferences cookie called ‘NID’ in their browsers. A browser sends this cookie with requests to Google’s sites. The NID cookie contains a unique ID Google uses to remember your preferences and other information, such as your preferred language (e.g. English), how many search results you wish to have shown per page (e.g. 10 or 20), and whether or not you wish to have Google’s SafeSearch filter turned on.<br/>Loss of the information stored in a preference cookie may make the website experience less functional but should not prevent it from working.<br/>Storage period: 30 days</p><p><strong>hjid</strong><br/>Hotjar deliver analytics tools that help us to better understand how our users navigate our website. Hotjar register anonymous data regarding patterns of movement and click per visit. The data is collectively gathered and displayed for us to be used for improvements of our website.</p><p>Storage period: 1 year</p>
		</div>
	</template>
	
	</vue-cookie-comply>

</template>

<script>

import Leader from '@/components/2023/Leader.vue'
import SectionHeader from '@/components/2023/SectionHeader.vue'
import Footer from '@/components/2023/Footer.vue'
import VideoHero from '@/components/2023/VideoHero.vue'
import ArticleOneCol from '@/components/2023/ArticleOneCol.vue'
import Journey from '@/components/2023/Journey.vue'
import Article from '@/components/2023/Article.vue'
import ImageBg from '@/components/2023/ImageBg.vue'
import NumbersSix from '@/components/2023/NumbersSix.vue'
import NumbersTwo from '@/components/2023/NumbersTwo.vue'
import RippleEffect from '@/components/2023/RippleEffect.vue'
import RippleEffectIntro from '@/components/2023/RippleEffectIntro.vue'
import Lightbox from '@/components/2023/Lightbox.vue'

export default {
	name: 'OnePage',
	components: {

		Article,
		SectionHeader,
		ArticleOneCol,
		Footer,
		VideoHero,
		Journey,
		ImageBg,
		NumbersSix,
		NumbersTwo,
		RippleEffect,
		RippleEffectIntro,
		Lightbox,
		Leader
		
	},
	data(){
		// hide things on mobile
		const deviceType = () => {
			const ua = navigator.userAgent;
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return "tablet";
			}
			else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return "mobile";
			}
			return "desktop";
		};
		let isDesktop = true;
		// isDesktop = false;

		if( deviceType() == 'mobile'){
			isDesktop = false;
		}

		return{
			isDesktop
		}
	}
}
</script>